import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import type {
  GetCustomerCountersQuery,
  GetCustomerCountersQueryVariables,
} from "../../API";
import { GET_CUSTOMER_COUNTERS } from "../../common/operations/queries";
import { useCustomerExternalIdGuard } from "../../common/hooks/useCustomerExternalIdGuard";
import { useCustomerIdGuard } from "../../common/hooks/useCustomerIdGuard";
import { handleApolloError } from "../../common/utils/handleApolloError";

export const useGetCustomerCounters = () => {
  const customerExternalId = useCustomerExternalIdGuard();
  const customerId = useCustomerIdGuard();

  const { data, loading, error } = useQuery<
    GetCustomerCountersQuery,
    GetCustomerCountersQueryVariables
  >(GET_CUSTOMER_COUNTERS, {
    variables: {
      customerExternalId,
      customerId,
    },
    skip: !customerExternalId,
    fetchPolicy: "cache-and-network",
    onError: handleApolloError,
  });

  const customerCounters = useMemo(
    () => data?.getCustomerCounters,
    [data?.getCustomerCounters]
  );

  return { customerCounters, loading, error } as const;
};
